import { useEffect, useMemo } from 'react';
import clsx from 'clsx';
import { $usersStore } from '@lib/store/userManagement';
import type { AccountResponse } from '@shared/api/rest/accounts';
import type { CardResponse } from '@shared/api/rest/cards';
import { UserType } from '@shared/api/rest/users';
import { SmallAccount } from './smallAccount';
import { SmallCard } from './smallCard';
import { Button, Icon, Text } from '@shared/widgets';
import PlusIcon from '@assets/icons/plus.svg';

interface IUserLongInfoItemProps {
  show: boolean;
  type: UserType;
  icon: React.ReactNode;
  userId: string;
  cards?: CardResponse[];
  accounts?: AccountResponse[];
  showAddModal: () => void;
  removeItem: (id: number) => void;
}

export const UserLongInfoItem = (props: IUserLongInfoItemProps) => {
  useEffect(() => {
    if (!props.cards) return;
    $usersStore.events.getBalances({
      cardIds: props.cards.map((card) => card.cardId),
      userId: props.userId,
    });
  }, []);

  const typeManager = useMemo(() => props.type === UserType.MANAGER, [props.type]);
  const typeUser = useMemo(() => UserType.USER, [props.type]);

  return (
    <div className={clsx('pt-5 pb-8 px-6 border-t border-t-gray-black', props.show ? 'block' : 'hidden')}>
      <div className='mb-6 flex items-center justify-between'>
        <div className='flex items-center'>
          <div className='w-8 h-8 mr-3 bg-ice dark:bg-eerie-black flex-none flex items-center justify-center'>{props.icon}</div>
          <Text weight='medium' size='sm'>
            {(typeManager && props.accounts?.length) || (typeUser && props.cards?.length)}
            <span className='opacity-60'>{(typeManager && ' Accounts') || (typeUser && ' Cards')}</span>
          </Text>
        </div>
        <Button color='outlined' className='flex-none !p-0 flex items-center justify-center text-center w-8 h-8 rounded' onClick={props.showAddModal}>
          <Icon icon={<PlusIcon />} color='inherit' />
        </Button>
      </div>
      {props.accounts && props.accounts.map((account) => <SmallAccount key={account.id} account={account} removeAccount={props.removeItem} />)}
      {props.cards && props.cards.map((card) => <SmallCard key={card.cardId} card={card} removeCard={props.removeItem} />)}
    </div>
  );
};
